import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {plainToClassFromExist} from "class-transformer";
import {ResultListApiModel} from "../models/result-list.api.model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {TransmissionApiModel} from "../models/transmission.api.model";


@Injectable()
export class TransmissionRestService {
  private readonly resource: string = '/transmissions';

  constructor(
    public http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public getTransmissionCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<TransmissionApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<TransmissionApiModel>>(environment.apiUrl + this.resource, {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<TransmissionApiModel>(TransmissionApiModel), result as object)));
  }
}
